export class PasswordMissmatchError extends Error {
  constructor() {
    super('The passwords are not identical.');
    this.name = 'PasswordMissmatchError';
  }
}

export class EmptyFieldsError extends Error {
  constructor() {
    super('Please fill out all fields.');
    this.name = 'EmptyFieldsError';
  }
}

export class UnauthorizedError extends Error {
  constructor() {
    super('You are not authorized to view this page');
    this.name = 'UnauthorizedError';
  }
}

export class ExtendedError extends Error {
  metadata?: Record<string, any>;

  constructor(message: string, metadata?: Record<string, any>) {
    super(message);
    this.name = 'ExtendedError';
    this.metadata = metadata;
  }
}
